// extracted by mini-css-extract-plugin
export default {"placeholder":"en1sE6KvSELu21Cas3cl","placeholderBox":"tAy3k4bQUG2EC3k6MfV6","placeholderAnimation":"k4Cu0hohK5f9ivBvV1Wo","placeholderInverted":"H0eaCpf4TPHpNf3FaDMW"};